import { render, staticRenderFns } from "./ActivityModal.vue?vue&type=template&id=58919960&scoped=true"
import script from "./ActivityModal.vue?vue&type=script&lang=js"
export * from "./ActivityModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityModal.vue?vue&type=style&index=0&id=58919960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58919960",
  null
  
)

export default component.exports